const BASE = (process.env.REACT_APP_API_URL || 'https://halfprice-ca-v2.onrender.com/api').replace(/\/+$/, '');

const req = async (path, options = {}) => {
  const token = localStorage.getItem('hp_token');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const url = `${BASE}${cleanPath}`;
  const res = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    ...options,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
};

// Deals
export const getDeals = (params = {}) => req(`/deals?${new URLSearchParams(params)}`);
export const getDeal = (id) => req(`/deals/${id}`);
export const claimDeal = (id, email) => req(`/deals/${id}/claim`, { method: 'POST', body: JSON.stringify({ consumer_email: email }) });
export const createDeal = (data) => req('/deals', { method: 'POST', body: JSON.stringify(data) });
export const updateDeal = (id, data) => req(`/deals/${id}`, { method: 'PATCH', body: JSON.stringify(data) });
export const deleteDeal = (id) => req(`/deals/${id}`, { method: 'DELETE' });

// Redemption verification (restaurant side)
export const verifyRedemptionCode = (code) => req('/deals/verify-code', { method: 'POST', body: JSON.stringify({ code }) });
export const getRecentRedemptions = () => req('/deals/redemptions/recent');

// Auth
export const registerBusiness = (data) => req('/auth/business/register', { method: 'POST', body: JSON.stringify(data) });
export const loginBusiness = (data) => req('/auth/business/login', { method: 'POST', body: JSON.stringify(data) });
export const registerConsumer = (data) => req('/auth/consumer/register', { method: 'POST', body: JSON.stringify(data) });
export const loginConsumer = (data) => req('/auth/consumer/login', { method: 'POST', body: JSON.stringify(data) });
export const resendVerification = (email) => req('/auth/business/resend-verification', { method: 'POST', body: JSON.stringify({ email }) });

// Business
export const getMyBusiness = () => req('/businesses/me');
export const updateMyBusiness = (data) => req('/businesses/me', { method: 'PATCH', body: JSON.stringify(data) });
export const getPublicBusiness = (id) => req(`/businesses/public/${id}`);

// Cities & cuisines
export const getCitiesAndCuisines = () => req('/cities');
export const getNeighbourhoods = (cityId) => req(`/cities/${cityId}/neighbourhoods`);

// Leads
export const submitLead = (data) => req('/leads', { method: 'POST', body: JSON.stringify(data) });

// Loyalty
export const getLoyaltyStamps = (email) => req(`/loyalty/${encodeURIComponent(email)}`);

// Deal editing
export const getDealForEdit = (id) => req(`/deals/${id}/edit`);

// Admin
export const adminSendEmail = (data) => req('/admin/send-email', { method: 'POST', body: JSON.stringify(data) });
export const adminUpdateLeadStatus = (id, status) => req(`/admin/leads/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status }) });

export const adminUpdateLeadSource = (id, source) => req(`/admin/leads/${id}/source`, { method: 'PATCH', body: JSON.stringify({ source }) });
export const adminGetEmailHistory = (email) => req(`/admin/email-history/${encodeURIComponent(email)}`);
export const adminGetEmailCounts = () => req('/admin/email-counts');

// Stripe payments
export const createCheckoutSession = (plan) =>
  req('/stripe/create-checkout-session', { method: 'POST', body: JSON.stringify({ plan }) });
export const openBillingPortal = () =>
  req('/stripe/portal', { method: 'POST' });
export const getSubscriptionStatus = () =>
  req('/stripe/status');

// Featured slots
export const getActiveFeaturedSlot = () => req('/featured-slots/active');
export const adminGetFeaturedSlots = (params = {}) => req(`/featured-slots?${new URLSearchParams(params)}`);
export const adminGetFeaturedCalendar = () => req('/featured-slots/calendar');
export const adminGetBusinessesWithDeals = () => req('/featured-slots/businesses-with-deals');
export const adminCreateFeaturedSlot = (data) => req('/featured-slots', { method: 'POST', body: JSON.stringify(data) });
export const adminUpdateFeaturedSlot = (id, data) => req(`/featured-slots/${id}`, { method: 'PATCH', body: JSON.stringify(data) });
export const adminCancelFeaturedSlot = (id) => req(`/featured-slots/${id}`, { method: 'DELETE' });

// Pro plan: set own deal as Deal of the Day
export const featureMyDeal = (id) => req(`/deals/${id}/feature`, { method: 'POST' });
